import {
  SearchAccreditedEstablishmentMarkersArgs,
  EstablishmentsBaseArgs,
  EstablishmentsArgs
} from '@/modules/accredited-establishments/api'
import {
  ACCREDITED_ESTABLISHMENT_MARKERS,
  ACCREDITED_ESTABLISHMENTS_LIST
} from '@/global/constants/reactQueryKeys'

type MakeSearchEstablishmentsQueryKeyArgs = EstablishmentsArgs

type MakeSearchEstablishmentMarkersQueryKeyArgs =
  SearchAccreditedEstablishmentMarkersArgs

const makeFilters = ({
  categoryIds,
  siteAccreditedNetworkId,
  specialtyId,
  subSpecialtyId,
  gender,
  appointmentType,
  providerName,
  radiusInMeters,
  placeId,
  isDefaultSearch,
  lat,
  lon
}: EstablishmentsBaseArgs) => {
  return {
    ...(categoryIds ? { categoryIds } : {}),
    ...(siteAccreditedNetworkId ? { siteAccreditedNetworkId } : {}),
    ...(specialtyId ? { specialtyId } : {}),
    ...(subSpecialtyId ? { subSpecialtyId } : {}),
    ...(gender ? { gender } : {}),
    ...(appointmentType ? { appointmentType } : {}),
    ...(providerName ? { providerName } : {}),
    ...(placeId ? { placeId } : { lat, lon }),
    ...(radiusInMeters ? { radiusInMeters } : {}),
    ...(isDefaultSearch !== undefined ? { isDefaultSearch } : {})
  }
}

const makeBaseQueryKey = (
  baseKey: string[],
  filters: EstablishmentsBaseArgs
) => [...baseKey, makeFilters(filters)]

const makeSearchEstablishmentsListQueryKey = (
  args: MakeSearchEstablishmentsQueryKeyArgs
) => makeBaseQueryKey(ACCREDITED_ESTABLISHMENTS_LIST, args)

const makeSearchEstablishmentMarkersQueryKey = (
  args: MakeSearchEstablishmentMarkersQueryKeyArgs
) => makeBaseQueryKey(ACCREDITED_ESTABLISHMENT_MARKERS, args)

export {
  makeSearchEstablishmentMarkersQueryKey,
  makeSearchEstablishmentsListQueryKey
}
export type {
  MakeSearchEstablishmentsQueryKeyArgs,
  MakeSearchEstablishmentMarkersQueryKeyArgs
}
